<svg
  version="1.1"
  id="Capa_1"
  xmlns="http://www.w3.org/2000/svg"
  xmlns:xlink="http://www.w3.org/1999/xlink"
  x="0px"
  y="0px"
  viewBox="0 0 550.801 550.801"
  style="enable-background: new 0 0 550.801 550.801"
  xml:space="preserve"
>
  <g>
    <path
      d="M154.388,331.099c0-14.012-12.551-19.564-28.215-19.564H115.47v39.14c3.087,0.405,6.803,0.405,12.15,0.405
		C141.832,351.079,154.388,345.727,154.388,331.099z"
    />
    <path
      d="M488.426,197.014H475.2v-63.817c0-0.401-0.063-0.799-0.116-1.205c-0.021-2.534-0.827-5.023-2.562-6.993L366.325,3.694
		c-0.032-0.034-0.063-0.045-0.085-0.076c-0.633-0.707-1.371-1.298-2.151-1.804c-0.231-0.158-0.464-0.287-0.706-0.422
		c-0.676-0.366-1.393-0.675-2.131-0.896c-0.2-0.053-0.38-0.135-0.58-0.19C359.87,0.119,359.037,0,358.193,0H97.2
		c-11.918,0-21.6,9.693-21.6,21.601v175.413H62.377c-17.049,0-30.873,13.818-30.873,30.87v160.542
		c0,17.044,13.824,30.876,30.873,30.876h13.224V529.2c0,11.907,9.682,21.601,21.6,21.601h356.4c11.907,0,21.6-9.693,21.6-21.601
		V419.302h13.226c17.044,0,30.871-13.827,30.871-30.87v-160.54C519.297,210.832,505.47,197.014,488.426,197.014z M97.2,21.601
		h250.193v110.51c0,5.967,4.841,10.8,10.8,10.8h95.407v54.108H97.2V21.601z M358.953,372.928h-30.697l-2.067-53.162
		c-0.611-16.686-1.239-36.872-1.239-57.056h-0.611c-4.335,17.716-10.099,37.48-15.456,53.771l-16.892,54.163h-24.5l-14.839-53.757
		c-4.525-16.274-9.271-36.05-12.559-54.177h-0.411c-0.82,18.744-1.458,40.17-2.479,57.473l-2.468,52.745h-29.046l8.859-138.85
		h41.818l13.597,46.354c4.324,16.062,8.651,33.359,11.739,49.644h0.622c3.918-16.073,8.654-34.403,13.179-49.854l14.839-46.143
		h40.985L358.953,372.928z M84.354,372.295V235.932c8.245-1.659,24.933-2.89,40.587-2.89c19.153,0,30.905,1.859,40.996,7.826
		c9.682,5.157,16.688,14.629,16.688,27.2c0,12.358-7.204,23.892-22.866,29.655v0.411c15.865,4.335,27.601,16.274,27.601,34.193
		c0,12.571-5.756,22.449-14.407,29.468c-10.104,8.031-27,12.557-54.601,12.557C102.898,374.352,91.371,373.323,84.354,372.295z
		 M453.601,523.347H97.2V419.302h356.4V523.347z M469.979,309.267c-10.716,10.088-26.578,14.628-45.119,14.628
		c-4.113,0-7.826-0.211-10.7-0.611v49.645h-31.118V235.932c9.682-1.659,23.282-2.89,42.44-2.89c19.354,0,33.159,3.715,42.43,11.129
		c8.859,7.003,14.84,18.544,14.84,32.137C482.752,289.902,478.228,301.43,469.979,309.267z"
    />
    <path
      d="M427.128,256.727c-6.387,0-10.705,0.62-12.973,1.242v40.982c2.679,0.623,5.97,0.823,10.494,0.823
		c16.695,0,27-8.438,27-22.655C451.649,264.342,442.79,256.727,427.128,256.727z"
    />
    <path
      d="M151.105,271.976c0-10.502-8.037-16.076-22.254-16.076c-6.795,0-10.716,0.411-13.387,0.822v32.348h10.291
		C142.249,289.069,151.105,282.287,151.105,271.976z"
    />
  </g>
  <g></g>
  <g></g>
  <g></g>
  <g></g>
  <g></g>
  <g></g>
  <g></g>
  <g></g>
  <g></g>
  <g></g>
  <g></g>
  <g></g>
  <g></g>
  <g></g>
  <g></g>
</svg>
